import Vue from 'vue';
import { getInstance } from '@/_kk_wallet_relock/plugins/vue';
import { Web3Provider } from '@ethersproject/providers';
import { Contract } from '@ethersproject/contracts';
import { getAddress } from '@ethersproject/address';
//import { multicall } from '@bonustrack/snapshot.js/src/utils';
//import spaces from '@/spaces';
import store from '@/store';
import abi from '@/helpers/abi';
import config from '@/helpers/config';
import wsProvider from '@/helpers/ws';
import rpcProvider from '@/helpers/rpc';
import '@ethersproject/units';
import { parseEther,formatEther } from '@ethersproject/units';
import {parseUnits,formatUnits} from "@ethersproject/units";
//import {rp} from "request-promise";

//const rp = import('request-promise');

import bus from '@/bus.js'
let popPoast = function(obj_lang){
  if(window.location.href.indexOf('stake') == -1){
    return
  }

  let str = obj_lang['en']
  if(window.localStorage.lang === 'zh' &&　obj_lang['zh']){
    str = obj_lang['zh']
  }
  bus.appvue.$toasted.show(str)
  setTimeout(() => {
    bus.appvue.app_key += 1
  }, 2000);
}

let auth;
let web3;
if(window.ethereum){
  web3 = new Web3Provider(window.ethereum);
}

const LAVA_ADDRESS = '';
const LAVA_ABI = '[{"inputs":[{"internalType":"address","name":"router","type":"address"},{"internalType":"address","name":"factory","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"delegator","type":"address"},{"indexed":true,"internalType":"address","name":"fromDelegate","type":"address"},{"indexed":true,"internalType":"address","name":"toDelegate","type":"address"}],"name":"DelegateChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"delegate","type":"address"},{"indexed":false,"internalType":"uint256","name":"previousBalance","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"newBalance","type":"uint256"}],"name":"DelegateVotesChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"dst","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"LPTokenClaimed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"dst","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"LiquidityAddition","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"log","type":"string"}],"name":"Log","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DELEGATION_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"DOMAIN_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"LPGenerationCompleted","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"LPperETHUnit","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"agreesToTermsOutlinedInLiquidityGenerationParticipationAgreement","type":"bool"}],"name":"addLiquidity","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"addLiquidityToUniswapCORExWETHPair","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint32","name":"","type":"uint32"}],"name":"checkpoints","outputs":[{"internalType":"uint32","name":"fromBlock","type":"uint32"},{"internalType":"uint256","name":"votes","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"claimLPTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"contractStartTimestamp","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"createUniswapPairMainnet","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"delegatee","type":"address"}],"name":"delegate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"delegatee","type":"address"},{"internalType":"uint256","name":"nonce","type":"uint256"},{"internalType":"uint256","name":"expiry","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"delegateBySig","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"delegator","type":"address"}],"name":"delegates","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"emergencyDrain24hAfterLiquidityGenerationEventIsDone","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"ethContributed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"feeDistributor","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getCurrentVotes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"blockNumber","type":"uint256"}],"name":"getPriorVotes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getSecondsLeftInLiquidityGenerationEvent","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"initialSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"liquidityGenerationOngoing","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"liquidityGenerationParticipationAgreement","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"numCheckpoints","outputs":[{"internalType":"uint32","name":"","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_feeDistributor","type":"address"}],"name":"setFeeDistributor","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_transferCheckerAddress","type":"address"}],"name":"setShouldTransferChecker","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenUniswapPair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalETHContributed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalLPTokensMinted","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"transferCheckerAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapFactory","outputs":[{"internalType":"contract IUniswapV2Factory","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapRouterV2","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"}]'



const JGN_TOKEN_ABI = '[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"PauserAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"}],"name":"PauserRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"constant":true,"inputs":[],"name":"INITIAL_SUPPLY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"addPauser","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"cap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isMinter","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isPauser","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renouncePauser","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]'


const STAKE_REWARD_ABI = '[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"reward","type":"uint256"}],"name":"RewardAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"reward","type":"uint256"}],"name":"RewardPaid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Staked","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Withdrawn","type":"event"},{"constant":true,"inputs":[],"name":"DURATION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"earned","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"exit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"getReward","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"halveTimes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"initreward","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lastTimeRewardApplicable","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lastUpdateTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lava","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"reward","type":"uint256"}],"name":"notifyRewardAmount","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"periodFinish","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"rewardPerToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"rewardPerTokenStored","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"rewardRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"rewards","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_y","type":"address"}],"name":"setJGN","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_y","type":"address"}],"name":"setLAVA","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_rewardDistribution","type":"address"}],"name":"setRewardDistribution","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"stake","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"starttime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userRewardPerTokenPaid","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"y","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"}]'

const STAKE_HT_REWARD_ABI = '[{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"reward","type":"uint256"}],"name":"RewardAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"reward","type":"uint256"}],"name":"RewardPaid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Staked","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Withdrawn","type":"event"},{"constant":true,"inputs":[],"name":"DURATION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"earned","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"exit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"getReward","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"halveTimes","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"initreward","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"isOwner","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lastTimeRewardApplicable","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lastUpdateTime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"lava","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"reward","type":"uint256"}],"name":"notifyRewardAmount","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"periodFinish","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"rewardPerToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"rewardPerTokenStored","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"rewardRate","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"rewards","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_y","type":"address"}],"name":"setLAVA","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_rewardDistribution","type":"address"}],"name":"setRewardDistribution","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"stake","outputs":[],"payable":true,"stateMutability":"payable","type":"function"},{"constant":true,"inputs":[],"name":"starttime","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userRewardPerTokenPaid","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"withdraw","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]'


const LP_POOL_ADDRESS = '0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e'

const LP_POOL_ADDRESS_ABI = '[{"inputs":[{"internalType":"contract IERC20","name":"_lava","type":"address"},{"internalType":"uint256","name":"_sushiPerBlock","type":"uint256"},{"internalType":"uint256","name":"_startBlock","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":true,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":true,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"EmergencyWithdraw","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":true,"internalType":"uint256","name":"pid","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Withdraw","type":"event"},{"inputs":[],"name":"lava","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"poolInfo","outputs":[{"internalType":"contract IERC20","name":"lpToken","type":"address"},{"internalType":"uint256","name":"allocPoint","type":"uint256"},{"internalType":"uint256","name":"lastRewardBlock","type":"uint256"},{"internalType":"uint256","name":"accSushiPerShare","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"startBlock","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"sushiPerBlock","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalAllocPoint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"","type":"address"}],"name":"userInfo","outputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"rewardDebt","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"poolLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_allocPoint","type":"uint256"},{"internalType":"contract IERC20","name":"_lpToken","type":"address"},{"internalType":"bool","name":"_withUpdate","type":"bool"}],"name":"add","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"uint256","name":"_allocPoint","type":"uint256"},{"internalType":"bool","name":"_withUpdate","type":"bool"}],"name":"set","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_from","type":"uint256"},{"internalType":"uint256","name":"_to","type":"uint256"}],"name":"getMultiplier","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"address","name":"_user","type":"address"}],"name":"pendingSushi","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"massUpdatePools","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"updatePool","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_pid","type":"uint256"}],"name":"emergencyWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}]'


const PAIR_POOL_ADDRESS_ABI = '[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]'

const GAS_LIMIT = 181500


const iLAVA_LAVA_ADDRESS = ''
const iLAVA_ADDRESS = ''
const iLAVA_ABI = '[{"inputs":[{"internalType":"address","name":"lavaGov","type":"address"},{"internalType":"address","name":"lavaToken","type":"address"},{"internalType":"address","name":"lavaTeam","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"lavaPerBlock","type":"uint256"}],"name":"ChangePerReward","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"donateLAVA","type":"uint256"}],"name":"DonateLAVA","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"superior","type":"address"},{"indexed":false,"internalType":"uint256","name":"mintLAVA","type":"uint256"}],"name":"MintILAVA","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferPrepared","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"lavaAmount","type":"uint256"}],"name":"PreDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"receiveLAVA","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"burnLAVA","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"feeLAVA","type":"uint256"}],"name":"RedeemILAVA","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"bool","name":"allowed","type":"bool"}],"name":"SetCantransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"lavaFeeBurnRatio","type":"uint256"}],"name":"UpdateLAVAFeeBurnRatio","type":"event"},{"inputs":[],"name":"_CAN_TRANSFER_","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_DOOD_GOV_","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAST_REWARD_BLOCK_","outputs":[{"internalType":"uint32","name":"","type":"uint32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAVA_BURN_ADDRESS_","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAVA_FEE_BURN_RATIO_","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAVA_PER_BLOCK_","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAVA_RATIO_","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAVA_TEAM_","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_LAVA_TOKEN_","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_NEW_OWNER_","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_OWNER_","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_SUPERIOR_RATIO_","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_TOTAL_BLOCK_DISTRIBUTION_","outputs":[{"internalType":"uint112","name":"","type":"uint112"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_TOTAL_BLOCK_REWARD_","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_TOTAL_STAKING_POWER_","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"alpha","outputs":[{"internalType":"uint112","name":"","type":"uint112"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"iLAVAAmount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"availableBalanceOf","outputs":[{"internalType":"uint256","name":"iLAVAAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"iLAVAAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lavaPerBlock","type":"uint256"}],"name":"changePerReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"claimOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lavaAmount","type":"uint256"}],"name":"donate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"emergencyWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getLAVAWithdrawFeeRatio","outputs":[{"internalType":"uint256","name":"feeRatio","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getLatestAlpha","outputs":[{"internalType":"uint256","name":"newAlpha","type":"uint256"},{"internalType":"uint256","name":"curDistribution","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"getSuperior","outputs":[{"internalType":"address","name":"superior","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lavaAmount","type":"uint256"}],"name":"getWithdrawResult","outputs":[{"internalType":"uint256","name":"lavaReceive","type":"uint256"},{"internalType":"uint256","name":"burnLAVAAmount","type":"uint256"},{"internalType":"uint256","name":"withdrawFeeLAVAAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"initOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"isUser","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"lavaBalanceOf","outputs":[{"internalType":"uint256","name":"lavaAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lavaAmount","type":"uint256"},{"internalType":"address","name":"superiorAddress","type":"address"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"lavaAmount","type":"uint256"}],"name":"preDepositedBlockReward","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"ilavaAmount","type":"uint256"},{"internalType":"bool","name":"all","type":"bool"}],"name":"redeem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"allowed","type":"bool"}],"name":"setCantransfer","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalBurnLAVA","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"iLAVASupply","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalUsers","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalWithdrawFee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"iLAVAAmount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"iLAVAAmount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"governance","type":"address"}],"name":"updateGovernance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"addr","type":"address"}],"name":"updateLAVAFeeBurnAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"lavaFeeBurnRatio","type":"uint256"}],"name":"updateLAVAFeeBurnRatio","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"superiorRatio","type":"uint256"}],"name":"updateSuperiorRatio","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"userInfo","outputs":[{"internalType":"uint128","name":"stakingPower","type":"uint128"},{"internalType":"uint128","name":"superiorSP","type":"uint128"},{"internalType":"address","name":"superior","type":"address"},{"internalType":"uint256","name":"credit","type":"uint256"},{"internalType":"uint256","name":"originAmount","type":"uint256"}],"stateMutability":"view","type":"function"}]'

const iLAVA_TEAM_ADDRESS = ''
//https://hecoinfo.com/tx/0x7479aa0c126924816ded9f5a7f713193a817067f60df60f4346779667fa7deb4

/*
wsProvider.on('block', blockNumber => {
  store.commit('GET_BLOCK_SUCCESS', blockNumber);
});
*/

const state = {
  injectedLoaded: false,
  injectedChainId: null,
  account: null,
  account_balance_eth: 0,
  account_balance_lp: 0,
  account_balance_lava: '0',

  account_balance_ilava: '0',
  status_ilava_approved: undefined,

  token_lava_price: '-',
  token_ht_price: '-',
  
  name: null,
  active: false,
  balances: {},
  blockNumber: 0,
  status_account_approved: false, //是否参与farm stake
};

// 
const mutations = {
  setWeb3Data(state,obj){
    for(let key in obj){
      state[key] = obj[key]
    }
  },
  LOGOUT(_state) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'injectedChainId', null);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'name', null);
    Vue.set(_state, 'active', false);
    Vue.set(_state, 'balances', {});
    console.debug('LOGOUT');
  },
  LOAD_WEB3_REQUEST() {
    console.debug('LOAD_WEB3_REQUEST');
  },
  LOAD_WEB3_SUCCESS() {
    console.debug('LOAD_WEB3_SUCCESS');
  },
  LOAD_WEB3_FAILURE(_state, payload) {
    console.debug('LOAD_WEB3_FAILURE', payload);
  },
  LOAD_PROVIDER_REQUEST() {
    console.debug('LOAD_PROVIDER_REQUEST');
  },
  LOAD_PROVIDER_SUCCESS(_state, payload) {
    Vue.set(_state, 'injectedLoaded', payload.injectedLoaded);
    Vue.set(_state, 'injectedChainId', payload.injectedChainId);
    Vue.set(_state, 'account', payload.account);
    Vue.set(_state, 'name', payload.name);
    console.debug('LOAD_PROVIDER_SUCCESS');
  },
  LOAD_PROVIDER_FAILURE(_state, payload) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'injectedChainId', null);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'active', false);
    console.debug('LOAD_PROVIDER_FAILURE', payload);
  },
  LOAD_BACKUP_PROVIDER_REQUEST() {
    console.debug('LOAD_BACKUP_PROVIDER_REQUEST');
  },
  LOAD_BACKUP_PROVIDER_SUCCESS(_state, payload) {
    console.debug('LOAD_BACKUP_PROVIDER_SUCCESS', payload);
  },
  LOAD_BACKUP_PROVIDER_FAILURE(_state, payload) {
    Vue.set(_state, 'injectedLoaded', false);
    Vue.set(_state, 'backUpLoaded', false);
    Vue.set(_state, 'account', null);
    Vue.set(_state, 'activeChainId', null);
    Vue.set(_state, 'active', false);
    console.debug('LOAD_BACKUP_PROVIDER_FAILURE', payload);
  },
  HANDLE_CHAIN_CHANGED() {
    console.debug('HANDLE_CHAIN_CHANGED');
  },
  HANDLE_ACCOUNTS_CHANGED(_state, payload) {
    Vue.set(_state, 'account', payload);
    console.debug('HANDLE_ACCOUNTS_CHANGED', payload);
  },
  HANDLE_CLOSE_CHANGED() {
    console.debug('HANDLE_CLOSE_CHANGED');
  },
  HANDLE_NETWORK_CHANGED() {
    console.debug('HANDLE_NETWORK_CHANGED');
  },
  LOOKUP_ADDRESS_REQUEST() {
    console.debug('LOOKUP_ADDRESS_REQUEST');
  },
  LOOKUP_ADDRESS_SUCCESS(_state, payload) {
    Vue.set(_state, 'name', payload);
    console.debug('LOOKUP_ADDRESS_SUCCESS');
  },
  LOOKUP_ADDRESS_FAILURE(_state, payload) {
    console.debug('LOOKUP_ADDRESS_FAILURE', payload);
  },
  RESOLVE_NAME_REQUEST() {
    console.debug('RESOLVE_NAME_REQUEST');
  },
  RESOLVE_NAME_SUCCESS() {
    console.debug('RESOLVE_NAME_SUCCESS');
  },
  RESOLVE_NAME_FAILURE(_state, payload) {
    console.debug('RESOLVE_NAME_FAILURE', payload);
  },
  SEND_TRANSACTION_REQUEST() {
    console.debug('SEND_TRANSACTION_REQUEST');
  },
  SEND_TRANSACTION_SUCCESS() {
    console.debug('SEND_TRANSACTION_SUCCESS');
  },
  SEND_TRANSACTION_FAILURE(_state, payload) {
    console.debug('SEND_TRANSACTION_FAILURE', payload);
  },
  SIGN_MESSAGE_REQUEST() {
    console.debug('SIGN_MESSAGE_REQUEST');
  },
  SIGN_MESSAGE_SUCCESS() {
    console.debug('SIGN_MESSAGE_SUCCESS');
  },
  SIGN_MESSAGE_FAILURE(_state, payload) {
    console.debug('SIGN_MESSAGE_FAILURE', payload);
  },
  GET_BLOCK_REQUEST() {
    console.debug('GET_BLOCK_REQUEST');
  },
  GET_BLOCK_SUCCESS(_state, payload) {
    Vue.set(_state, 'blockNumber', payload);
    console.debug('GET_BLOCK_SUCCESS', payload);
  },
  GET_BLOCK_FAILURE(_state, payload) {
    console.debug('GET_BLOCK_FAILURE', payload);
  },
  METADATA_SUCCESS(_state, payload) {
    Vue.set(_state, 'spaces', payload);
    console.debug('METADATA_SUCCESS');
  }
};

// 
const actions = {
  login: async ({ dispatch }, connector = 'injected') => {
    console.log('into----web3.ts login()----')
    auth = getInstance();
    await auth.login(connector);
    if (auth.provider) {
      web3 = new Web3Provider(auth.provider);
      await dispatch('loadWeb3');
    }
  },
  logout: async ({ commit }) => {
    Vue.prototype.$auth.logout();
    commit('LOGOUT');
  },
  loadWeb3: async ({ commit, dispatch }) => {
    commit('LOAD_WEB3_REQUEST');
    try {
      await dispatch('loadProvider');
      await dispatch('lookupAddress');
      commit('LOAD_WEB3_SUCCESS');
      if (!state.injectedLoaded || state.injectedChainId !== config.chainId) {
        await dispatch('loadBackupProvider');
      } else {
        /**
        this.providerStatus.activeChainId = this.providerStatus.injectedChainId;
        this.providerStatus.injectedActive = true;
        if (this.providerStatus.account)
          this.fetchUserBlockchainData(this.providerStatus.account);
        */
      }
    } catch (e) {
      commit('LOAD_WEB3_FAILURE', e);
      return Promise.reject();
    }
  },
  loadProvider: async ({ commit, dispatch }) => {
    commit('LOAD_PROVIDER_REQUEST');
    try {
      if (auth.provider.removeAllListeners) auth.provider.removeAllListeners();
      if (auth.provider.on) {
        auth.provider.on('chainChanged', async () => {
          commit('HANDLE_CHAIN_CHANGED');
          if (state.active) {
            await dispatch('loadWeb3');
          }
        });
        auth.provider.on('accountsChanged', async accounts => {
          if (accounts.length === 0) {
            if (state.active) await dispatch('loadWeb3');
          } else {
            commit('HANDLE_ACCOUNTS_CHANGED', accounts[0]);
            await dispatch('loadWeb3');
          }
        });
        auth.provider.on('disconnect', async () => {
          commit('HANDLE_CLOSE');
          if (state.active) await dispatch('loadWeb3');
        });
        auth.provider.on('networkChanged', async () => {
          commit('HANDLE_NETWORK_CHANGED');
          if (state.active) {
            await dispatch('loadWeb3');
          }
        });
      }
      const network = await web3.getNetwork();
      const accounts = await web3.listAccounts();
      const account = accounts.length > 0 ? accounts[0] : null;
      commit('LOAD_PROVIDER_SUCCESS', {
        injectedLoaded: true,
        injectedChainId: network.chainId,
        account,
        name
      });
    } catch (e) {
      commit('LOAD_PROVIDER_FAILURE', e);
      return Promise.reject();
    }
  },
  loadBackupProvider: async ({ commit }) => {
    try {
      web3 = rpcProvider;
      const network = await rpcProvider.getNetwork();
      commit('LOAD_BACKUP_PROVIDER_SUCCESS', {
        injectedActive: false,
        backUpLoaded: true,
        account: null,
        activeChainId: network.chainId
        // backUpWeb3: web3,
      });
    } catch (e) {
      commit('LOAD_BACKUP_PROVIDER_FAILURE', e);
      return Promise.reject();
    }
  },
  lookupAddress: async ({ commit }) => {
    commit('LOOKUP_ADDRESS_REQUEST');
    try {
      const name = await web3.lookupAddress(state.account);
      commit('LOOKUP_ADDRESS_SUCCESS', name);
      return name;
    } catch (e) {
      commit('LOOKUP_ADDRESS_FAILURE', e);
    }
  },
  resolveName: async ({ commit }, payload) => {
    commit('RESOLVE_NAME_REQUEST');
    try {
      const address = await web3.resolveName(payload);
      commit('RESOLVE_NAME_SUCCESS');
      return address;
    } catch (e) {
      commit('RESOLVE_NAME_FAILURE', e);
      return Promise.reject();
    }
  },
  sendTransaction: async (
    { commit },
    [contractType, contractAddress, action, params]
  ) => {
    commit('SEND_TRANSACTION_REQUEST');
    try {
      const signer = web3.getSigner();
      const contract = new Contract(
        getAddress(contractAddress),
        abi[contractType],
        web3
      );
      const contractWithSigner = contract.connect(signer);
      const tx = await contractWithSigner[action](...params);
      await tx.wait();
      commit('SEND_TRANSACTION_SUCCESS');
      return tx;
    } catch (e) {
      commit('SEND_TRANSACTION_FAILURE', e);
      return Promise.reject();
    }
  },
  signMessage: async ({ commit }, message) => {
    commit('SIGN_MESSAGE_REQUEST');
    try {
      const signer = web3.getSigner();
      const sig = await signer.signMessage(message);
      commit('SIGN_MESSAGE_SUCCESS');
      return sig;
    } catch (e) {
      commit('SIGN_MESSAGE_FAILURE', e);
      return Promise.reject(e);
    }
  },
  getBlockNumber: async ({ commit }) => {
    commit('GET_BLOCK_REQUEST');
    try {
      const blockNumber: any = await rpcProvider.getBlockNumber();
      commit('GET_BLOCK_SUCCESS', parseInt(blockNumber));
      return blockNumber;
    } catch (e) {
      commit('GET_BLOCK_FAILURE', e);
      return Promise.reject();
    }
  },

  getBalance: async ({ commit }, address) => {
    
    console.log('---------------')

    /*
    const signer = web3.getSigner();
    const tx = await signer.sendTransaction({
      to: "0xAa1acBfA7C5b4B3C7E35c969f727262DAAbc6126",
      value: parseEther('0.1')
    });
    */

    const signer = web3.getSigner();

    let UNILP_Address = '0x1c5DEe94a34D795f9EEeF830B68B80e44868d316'
    let vaults_address = '0xc6Df9840872f701662c6Fb25352D6150EcFc53AF'

    let UNILP_ABI = '[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Burn","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"sender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount0In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1In","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount0Out","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount1Out","type":"uint256"},{"indexed":true,"internalType":"address","name":"to","type":"address"}],"name":"Swap","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint112","name":"reserve0","type":"uint112"},{"indexed":false,"internalType":"uint112","name":"reserve1","type":"uint112"}],"name":"Sync","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"MINIMUM_LIQUIDITY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"burn","outputs":[{"internalType":"uint256","name":"amount0","type":"uint256"},{"internalType":"uint256","name":"amount1","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint112","name":"_reserve0","type":"uint112"},{"internalType":"uint112","name":"_reserve1","type":"uint112"},{"internalType":"uint32","name":"_blockTimestampLast","type":"uint32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_token0","type":"address"},{"internalType":"address","name":"_token1","type":"address"}],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"kLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"liquidity","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"price0CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"price1CumulativeLast","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"skim","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount0Out","type":"uint256"},{"internalType":"uint256","name":"amount1Out","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"swap","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"sync","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"token0","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"token1","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"}]'
    let vaults_abi = '[{"inputs":[{"internalType":"address","name":"_token","type":"address"},{"internalType":"address","name":"_governance","type":"address"},{"internalType":"address","name":"_controller","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"available","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"balance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"controller","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"deposit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"depositAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"earn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getRatio","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"governance","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"reserve","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"harvest","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"max","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"min","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_controller","type":"address"}],"name":"setController","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_governance","type":"address"}],"name":"setGovernance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_min","type":"uint256"}],"name":"setMin","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_shares","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawAll","outputs":[],"stateMutability":"nonpayable","type":"function"}]'

    const UNILP_Contract = new Contract(UNILP_Address, UNILP_ABI, web3);

    const vaults_contract = new Contract(vaults_address,vaults_abi,web3);

    const UNILPWithSigner = UNILP_Contract.connect(signer);

    const valuts_withSigner = vaults_contract.connect(signer);

    const num = parseUnits("1.0", 36);

    const num2 = parseUnits('0.03',18);


    const tx1 = await UNILPWithSigner.approve(vaults_address,num);

    const tx2 = await valuts_withSigner.deposit(num2);

    //let name = await daiContract.name();
    //console.log(name);

    /*
    if(!address){
      console.log('getBalance() - need adrress.')
    }
    try {
      console.log('=====地址写死了，注意修改')
      const b_num = await web3.getBalance("0xAa1acBfA7C5b4B3C7E35c969f727262DAAbc6126")
      console.log('=====balance')
      console.log(parseInt(b_num))
      return parseInt(b_num);
    } catch (e) {
      return Promise.reject();
    }
    */
  },

  
  // //得到还没有收割的奖励
  // getPendingReward:async ({ commit }, address) => {
  //   const signer = web3.getSigner();
  //   const vaults_contract = new Contract(CORE_VALUTS_ADDRESS,CORE_VALUTS_ABI,web3);
  //   const vaults_WithSigner = vaults_contract.connect(signer);
  //   let b_num = await vaults_WithSigner.pendingCore(0,address);
  //   //let b = parseInt(b_num)/1e18;
  //   let b = formatUnits(b_num,18)
  //   console.log(b);
  //   return b;
  // },


  

  

  //得到我的DPO数量
  getLAVABalance: async ({ commit }, address) => {
    const signer = web3.getSigner();
    const lp_contract = new Contract(LAVA_ADDRESS, LAVA_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.balanceOf(address);
    //let b = parseInt(b_num)/1e18;
    let b = formatUnits(b_num,18)
    return b;
  },

  metadata: async ({ commit }) => {
    // try {
    //   const noDecimals = ['yearn'];
    //   const response = await multicall(
    //     rpcProvider,
    //     abi['TestToken'],
    //     Object.values(spaces)
    //       .filter((space: any) => !noDecimals.includes(space.key))
    //       .map((space: any) => [space.address, 'decimals', []])
    //   );
    //   const payload = Object.fromEntries(
    //     response.map((item, i) => [
    //       // @ts-ignore
    //       Object.values(spaces).filter(
    //         (space: any) => !noDecimals.includes(space.key)
    //       )[i].address,
    //       { decimals: response[i][0] }
    //     ])
    //   );
    //   payload['0xBa37B002AbaFDd8E89a1995dA52740bbC013D992'] = { decimals: 18 };
    //   commit('METADATA_SUCCESS', payload);
    //   return payload;
    // } catch (e) {
    //   console.log(e);
    //   return Promise.reject();
    // }
  },

  //your balance
  getStakeTokenBalance:async ({ commit },obj) => {
    console.log('=== into === getStakeTokenBalance',obj)
    let {id,stakeTokenAddress, address} = obj;

    if(id == 'HT' || id == 'HT2' || id == 'HT3'){
      let b_num = await web3.getBalance(address);
      b_num = formatEther(b_num);
      return b_num;
    }

    const signer = web3.getSigner();
    const vaults_contract = new Contract(stakeTokenAddress, JGN_TOKEN_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);

    let b_num = await vaults_WithSigner.balanceOf(address);
    let decimals = 18
    if(stakeTokenAddress == '0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047'){
      decimals = 8
    }
    else if(stakeTokenAddress == '0x9ef1918a9beE17054B35108bD3E2665e2Af1Bb1b'){
      decimals = 4
    }
    else if(stakeTokenAddress == '0xE1d1F66215998786110Ba0102ef558b22224C016'){
      decimals = 8
    }
    let b = formatUnits(b_num,decimals);
    console.log(b_num)
    console.log(b)
    return b;
  },


  //current staked
  getStakeTokenStaked:async ({ commit },obj) => {
    console.log('=== into === getStakeTokenStaked',obj)
    let {stakeTokenAddress, stakeRewardAddress, address} = obj
    
    const signer = web3.getSigner();
    const vaults_contract = new Contract(stakeRewardAddress, STAKE_REWARD_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    let b_num = await vaults_WithSigner.balanceOf(address);
    let decimals = 18
    if(stakeTokenAddress == '0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047'){
      decimals = 8
    }
    else if(stakeTokenAddress == '0x9ef1918a9beE17054B35108bD3E2665e2Af1Bb1b'){
      decimals = 4
    }
    else if(stakeTokenAddress == '0xE1d1F66215998786110Ba0102ef558b22224C016'){
      decimals = 8
    }
    let b = formatUnits(b_num,decimals);
    return b;
  },

  //Rewards Available
  getStakeRewardAvaiable:async ({ commit },obj) => {
    // console.log('=== into === getStakeRewardAvaiable')
    let {stakeRewardAddress, address} = obj
    const signer = web3.getSigner();
    const vaults_contract = new Contract(stakeRewardAddress, STAKE_REWARD_ABI, web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    let b_num = await vaults_WithSigner.earned(address);
    let decimals = 18;
    if(stakeRewardAddress == '0xc9E553A9D9E78E5E8476655bcE2f34291dd7F473'){
      decimals = 8;
    }
    else if(stakeRewardAddress == '0x263B2612D60061e7c877028f037837214CBb5fA8'){
      decimals = 8;
    }
    else if(stakeRewardAddress == '0x0004D34997Fe9ab10fD4AB889D16f87f38912330'){
      decimals = 8;
    }
    else if(stakeRewardAddress == '0x856103f759be1c18fA642247544F29BA2C1605E0'){
      decimals = 10;
    }
    else if(stakeRewardAddress == '0x8170E35C9676dcba9263ED612fd23871C0611f69'){
      decimals = 10;
    }
    let b = formatUnits(b_num,decimals);
    return b;
  },


  hasApproveStakeToken: async ({ commit },obj) => {
    console.log('=== into === hasApproveStakeToken')
    let {id,stakeTokenAddress,stakeRewardAddress, address} = obj
    if(id == 'HT' || id == 'HT2' || id == 'HT3'){
      return true;
    }
    const signer = web3.getSigner();
    const lp_contract = new Contract(stakeTokenAddress, JGN_TOKEN_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.allowance(address,stakeRewardAddress);
    if(b_num > 0){
      return true;
    }
    return false;
  },

  
  approveStakeToken: async (context,obj) => {
    console.log('=== into === approveStakeToken')
    let {stakeTokenAddress,stakeRewardAddress} = obj
    const signer = web3.getSigner();
    const lp_contract = new Contract(stakeTokenAddress, JGN_TOKEN_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    if(stakeTokenAddress == '0x8F67854497218043E1f72908FFE38D0Ed7F24721'){
      await lp_WithSigner.approve(stakeRewardAddress,parseUnits('1',28));
    }
    else{
      await lp_WithSigner.approve(stakeRewardAddress,parseUnits('1',36));
    }
    // callback
    if(obj && obj.callback){
      obj.callback()
    }
  },

  //stake
  //need add alert
  stakeStakeToken: async ({ commit },obj) => {
    console.log('=== into === stakeStakeToken',obj)
    let {id,stakeTokenAddress, stakeRewardAddress, num} = obj

    let status = 0
    if(id == 'HT' || id == 'HT2' || id == 'HT3'){
      const signer = web3.getSigner();
      const vaults_contract = new Contract(stakeRewardAddress, STAKE_HT_REWARD_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let sendNum = parseEther(num);
      var tx = await vaults_WithSigner.stake({value:sendNum,gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      status = parseInt(receipt['status'])
      //success if status == 1
    }
    else{
      const signer = web3.getSigner();
      const vaults_contract = new Contract(stakeRewardAddress, STAKE_REWARD_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let decimals = 18
      if(stakeTokenAddress == '0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047'){
        decimals = 8
      }
      else if(stakeTokenAddress == '0x9ef1918a9beE17054B35108bD3E2665e2Af1Bb1b'){
        decimals = 4
      }
      else if(stakeTokenAddress == '0xE1d1F66215998786110Ba0102ef558b22224C016'){
        decimals = 8
      }
      var tx = await vaults_WithSigner.stake(parseUnits(num,decimals),{gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      status = parseInt(receipt['status'])
      //success if status == 1
    }

    // toast
    if(status == 1){
      popPoast({
        en: 'Staked successfully',
        zh: '质押成功',
      })
    }else{
      popPoast({
        en: 'Staked failed',
        zh: '质押失败',
      })
    }
  },

  //unstake
  //need add alert
  unstakeStakeToken: async ({ commit }, obj) => {
    console.log('=== into === unStakeJGN')
    let {id,stakeTokenAddress, stakeRewardAddress, num} = obj
    
    let status = 0

    if(id == 'HT' || id == 'HT2' || id == 'HT3'){
      const signer = web3.getSigner();
      const vaults_contract = new Contract(stakeRewardAddress, STAKE_HT_REWARD_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let sendNum = parseEther(num);
      var tx = await vaults_WithSigner.withdraw(sendNum,{gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      status = parseInt(receipt['status'])
      //success if status == 1
    }
    else{
      const signer = web3.getSigner();
      const vaults_contract = new Contract(stakeRewardAddress, STAKE_REWARD_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let decimals = 18
      if(stakeTokenAddress == '0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047'){
        decimals = 8
      }
      else if(stakeTokenAddress == '0x9ef1918a9beE17054B35108bD3E2665e2Af1Bb1b'){
        decimals = 4
      }
      else if(stakeTokenAddress == '0xE1d1F66215998786110Ba0102ef558b22224C016'){
        decimals = 8
      }
      var tx = await vaults_WithSigner.withdraw(parseUnits(num,decimals),{gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      status = parseInt(receipt['status'])
      //success if status == 1
    }

    // toast
    if(status == 1){
      popPoast({
        en: 'Unstaked successfully',
        zh: '取消质押成功',
      })
    }else{
      popPoast({
        en: 'Unstaked failed',
        zh: '取消质押失败',
      })
    }
  },

  //claim
  //need add alert
  claimReward: async ({ commit },stakeRewardAddress) => {
    console.log('=== into === stakeStakeToken')
    const signer = web3.getSigner();
    const vaults_contract = new Contract(stakeRewardAddress, STAKE_REWARD_ABI,web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    var tx = await vaults_WithSigner.getReward({gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      let status = parseInt(receipt['status'])
      //success if status == 1
      if(status == 1){
        popPoast({
          en: 'Claimed successfully',
          zh: '提取奖励成功',
        })
      }else{
        popPoast({
          en: 'Claimed failed',
          zh: '提取奖励失败',
        })
      }
  },

  //exit
  //need add alert
  exitStake: async ({ commit },stakeRewardAddress) => {
    console.log('=== into === stakeStakeToken')
    const signer = web3.getSigner();
    const vaults_contract = new Contract(stakeRewardAddress, STAKE_REWARD_ABI,web3);
    const vaults_WithSigner = vaults_contract.connect(signer);
    var tx = await vaults_WithSigner.exit({gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      let status = parseInt(receipt['status'])
      //success if status == 1
      if(status == 1){
        popPoast({
          en: 'Exited successfully',
          zh: '退出成功',
        })
      }else{
        popPoast({
          en: 'Exited failed',
          zh: '退出失败',
        })
      }
  },


  getTotalStake:async ({ commit },obj) => {
    console.log('=== into === getTotalStake',obj)

    let {id,stakeTokenAddress, stakeRewardAddress} = obj

    // if(id == 'HT' || id == 'HT2' || id == 'HT3'){
    //   let b_num = await web3.getBalance(stakeRewardAddress);
    //   b_num = formatEther(b_num);
    //   return b_num;
    // }

    const signer = web3.getSigner();
    const lp_contract = new Contract(stakeTokenAddress, JGN_TOKEN_ABI, web3);
    const vaults_WithSigner = lp_contract.connect(signer);
    let b_num = await vaults_WithSigner.balanceOf(stakeRewardAddress);
    let decimals = 18
    // if(stakeTokenAddress == '0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047'){
    //   decimals = 8
    // }
    // else if(stakeTokenAddress == '0x9ef1918a9beE17054B35108bD3E2665e2Af1Bb1b'){
    //   decimals = 4
    // }
    // else if(stakeTokenAddress == '0xE1d1F66215998786110Ba0102ef558b22224C016'){
    //   decimals = 8;
    // }
    let b = formatUnits(b_num,decimals);
    // console.log('getTotalStake:',b);
    return b;
  },

  Circulate:async({commit},obj) => {

  
  //   let a = ['0x1c2c1bf8a560bb72e18e7a23397ab7190276565b','0x981d2e2fa66864885362f3c265a721b59c8e6d6e',
  // '0xed69e40626d56d49579aecdc8566727d3ce792c3','0x0c522e4876bc65d27c93360993272c922829fb5b','0x5038e1F580a25D2CB9081d7cB867C815C9626a26','0x9d90609b6c90cc378fe15bfa9edf249d3f3abf6e']
  //   let sum = 0
  //   for (let index = 0; index < a.length; index++) {
  //     const element = a[index];

  //     const signer = web3.getSigner();
  //     const lp_contract = new Contract(LAVA_ADDRESS, LAVA_ABI, web3);
  //     const lp_WithSigner = lp_contract.connect(signer);
  //     const b_num = await lp_WithSigner.balanceOf(element);
  //     let b = parseInt(b_num)/1e18;
  //     // let b = formatUnits(b_num,18)
  //     sum = sum + b
  //   }
  //   return 100000000 - sum

  


    const signer = web3.getSigner();
      const lp_contract = new Contract(LAVA_ADDRESS, LAVA_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      const b_num = await lp_WithSigner.balanceOf('0x1111111111111111111111111111111111111111');
      let b = parseInt(b_num)/1e18;
      // let b = formatUnits(b_num,18)
     return b;

  },

  Circulate2:async({commit},obj) => {
    const signer = web3.getSigner();
    const lp_contract = new Contract(LAVA_ADDRESS, LAVA_ABI, web3);
    const lp_WithSigner = lp_contract.connect(signer);
    const b_num = await lp_WithSigner.balanceOf('0x1111111111111111111111111111111111111111');
    let b = parseInt(b_num)/1e18;
    // let b = formatUnits(b_num,18)
    b = 100000000 - b;
   return b;
  },


  pendingSushi:async ({ commit },obj) => {
    console.log('=== into === pendingSushi',obj)
    let {num_id, address} = obj;

    const signer = web3.getSigner();
    const lp_contract = new Contract(LP_POOL_ADDRESS, LP_POOL_ADDRESS_ABI, web3);
    const vaults_WithSigner = lp_contract.connect(signer);
    let b_num = await vaults_WithSigner.pendingSushi(num_id,address);
    let decimals = 18;
    let b = formatUnits(b_num,decimals);
    return b;
  },

  //need add alert
  depositLP: async ({ commit },obj) => {
    console.log('=== into === depositLP',obj)
    let {num_id, address,num} = obj;

      const signer = web3.getSigner();
      const vaults_contract = new Contract(LP_POOL_ADDRESS, LP_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let decimals = 18
      var tx = await vaults_WithSigner.deposit(num_id,parseUnits(num,decimals),{gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      let status = parseInt(receipt['status'])
      //success if status == 1
      if(status == 1){
        popPoast({
          en: 'Staked successfully',
          zh: '质押成功',
        })
      }else{
        popPoast({
          en: 'Staked failed',
          zh: '质押失败',
        })
      }
  },

  //need add alert
  withdrawLP: async ({ commit },obj) => {
    console.log('=== into === withdrawLP',obj)
    let {num_id, address,num} = obj;
      const signer = web3.getSigner();
      const vaults_contract = new Contract(LP_POOL_ADDRESS, LP_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let decimals = 18
      var tx = await vaults_WithSigner.withdraw(num_id,parseUnits(num,decimals),{gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      let status = parseInt(receipt['status'])
      //success if status == 1
      if(status == 1){
        popPoast({
          en: 'Unstaked successfully',
          zh: '取消质押成功',
        })
      }else{
        popPoast({
          en: 'Unstaked failed',
          zh: '取消质押失败',
        })
      }
    },

    //need add alert
    rewardLP: async ({ commit },obj) => {
      console.log('=== into === rewardLP',obj)
      let {num_id, address} = obj;
        const signer = web3.getSigner();
        const vaults_contract = new Contract(LP_POOL_ADDRESS, LP_POOL_ADDRESS_ABI,web3);
        const vaults_WithSigner = vaults_contract.connect(signer);
        let decimals = 18
        var tx = await vaults_WithSigner.deposit(num_id,0,{gasLimit:GAS_LIMIT});
      await web3.waitForTransaction(tx.hash);
      let receipt = await web3.getTransactionReceipt(tx.hash);
      let status = parseInt(receipt['status'])
      //success if status == 1
      if(status == 1){
        popPoast({
          en: 'Claimed successfully',
          zh: '提取奖励成功',
        })
      }else{
        popPoast({
          en: 'Claimed failed',
          zh: '提取奖励失败',
        })
      }
    },


    
    getHasStakeBalance:async ({ commit }, obj) => {
      console.log('=== into === getHasStakeBalance',obj)
      let {num_id, address} = obj;
      const signer = web3.getSigner();
      const vaults_contract = new Contract(LP_POOL_ADDRESS, LP_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.userInfo(num_id,address);
      b_num = b_num[0];
      let b = formatUnits(b_num,18)
      return b;
    },


    getLPPoolTotalValue:async ({ commit }, obj) => {
      console.log('=== into === getLPPoolTotalValue',obj)
      let {token_address} = obj;
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf(LP_POOL_ADDRESS);
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      let ration = balance / totalSuppy


      let usdt = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let wht = '0x5545153ccfca01fbd7dd11c0b23ba694d9509a6f';
      let wht_price = 36;
      let eth = '0x64ff637fb478863b7468bc97d30a5bf3a428a1fd';
      let eth_price = 4367;
      let lava_token = '0x56f95662e71f30b333b456439248c6de589082a4';
      let lava_price = 0.65;
      let husd = '0x0298c2b32eaE4da002a15f36fdf7615BEa3DA047'.toLowerCase()

      let nuls = '0xd938e45680da19ad36646ae8d4c671b2b1270f39'.toLowerCase()
      let nuls_price = 1.37
      

      if(token0 == usdt || token1 == usdt){
        if(token0 == usdt){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*2*ration;
        }
      }
      else if(token0 == husd || token1 == husd){
        if(token0 == husd){
          let b = formatUnits(token0Num,8)
          return parseFloat(b)*2*ration;
        }
        else{
          let b = formatUnits(token1Num,8)
          return parseFloat(b)*2*ration;
        }
      }
      else if(token0 == wht || token1 == wht){
        if(token0 == wht){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*wht_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*wht_price*2*ration;
        }
      }
      else if(token0 == eth || token1 == eth){
        if(token0 == eth){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*eth_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*eth_price*2*ration;
        }
      }
      else if(token0 == nuls || token1 == nuls){
        if(token0 == nuls){
          let b = formatUnits(token0Num,8)
          return parseFloat(b)*nuls_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,8)
          return parseFloat(b)*nuls_price*2*ration;
        }
      }
      else if(token0 == lava_token || token1 == lava_token){
        // console.log('---------------------------------------------------')
        // console.log('into else if(token0 == lava || token1 == lava){')
        if(token0 == lava_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
      }
      return 1;
    },

    getLavaPrice:async ({ commit }, obj) => {
      
      console.log('=== into === getJGNPrice')

      let bnbPrice = 1.0;
      {
        let token_address = '0x58f876857a02d6762e0101bb5c46a8c1ed44dc16'
        const signer = web3.getSigner();
        const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
        const vaults_WithSigner = vaults_contract.connect(signer);
        // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
        let result = await vaults_WithSigner.getReserves();
        

        let token0Num = result[0]
        let token1Num = result[1]

        token0Num = formatUnits(token0Num,18)
        token0Num = parseFloat(token0Num)

        // console.log(token0Num)

        token1Num = formatUnits(token1Num,18)
        token1Num = parseFloat(token1Num)

        // console.log(token1Num)
        
        let price = token1Num / token0Num
        // console.log('-------------------BNB Price')
        // console.log(price)
       
        bnbPrice = price 
      }


      
      let token_address = '0x7275278c94b5e20708380561c4af98f38ddc6374'
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      token0Num = formatUnits(token0Num,18)
      token0Num = parseFloat(token0Num)

      token1Num = formatUnits(token1Num,18)
      token1Num = parseFloat(token1Num)
      
      let price = token0Num / token1Num
      // console.log('-------------------JGN/BNB Price')
      // console.log(price)
      let priceUSD = price * bnbPrice
      console.log('-------------------JGN Price')
      console.log(priceUSD)
      return priceUSD;
      
    },


    getHTPrice:async ({ commit }, obj) => {
      
      console.log('=== into === getBNBPrice')
      
      let token_address = '0x58f876857a02d6762e0101bb5c46a8c1ed44dc16'
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
      let result = await vaults_WithSigner.getReserves();
      

      let token0Num = result[0]
      let token1Num = result[1]

      

      token0Num = formatUnits(token0Num,18)
      token0Num = parseFloat(token0Num)

      // console.log(token0Num)

      token1Num = formatUnits(token1Num,18)
      token1Num = parseFloat(token1Num)

      // console.log(token1Num)
      
      let price = token1Num / token0Num
      // console.log('-------------------')
      // console.log(price)
      return price;
      
    },


    getGenePrice:async ({ commit }, obj) => {
      
      // console.log('=== into === getGenePrice')

      return 1.0;
      
      let token_address = '0x58f876857a02d6762e0101bb5c46a8c1ed44dc16'
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
      let result = await vaults_WithSigner.getReserves();
      

      let token0Num = result[0]
      let token1Num = result[1]

      

      token0Num = formatUnits(token0Num,18)
      token0Num = parseFloat(token0Num)

      console.log(token0Num)

      token1Num = formatUnits(token1Num,18)
      token1Num = parseFloat(token1Num)

      console.log(token1Num)
      
      let price = token1Num / token0Num
      // console.log('-------------------gene price')
      // console.log(price)
      return price;
      
    },

    getLAVARECLPTotalValue3:async ({ commit }, obj) => {
      
      // console.log('=== into === getJGNBNBLPTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x7275278C94b5e20708380561C4Af98F38dDC6374', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      // console.log('------------1')
      // console.log('token0:',token0)

      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      // console.log('------------2')
      // console.log('token1:',token1)

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------3')
      // console.log('totalSupply:',totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0xE613ED9d4Cf1ea881B72cF435681a93a3e9ba20A');

      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      // console.log('---------------4')
      // console.log('balance:',balance)

      let ration = balance / totalSuppy


      // console.log('-----------')

      let lava_token = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
      let lava_price = 420;

      if(token0 == lava_token || token1 == lava_token){
        if(token0 == lava_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
      }
      return 1;
    },


    getLAVARECLPTotalValue4:async ({ commit }, obj) => {
      
      // console.log('=== into === getJGNBNBLPTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x7275278C94b5e20708380561C4Af98F38dDC6374', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      // console.log('------------1')
      // console.log('token0:',token0)

      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      // console.log('------------2')
      // console.log('token1:',token1)

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------3')
      // console.log('totalSupply:',totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x4C04384b19DdA6a38AD254b81B1A2358eb4AaDc6');

      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      // console.log('---------------4')
      // console.log('balance:',balance)

      let ration = balance / totalSuppy


      // console.log('-----------')

      let lava_token = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
      let lava_price = 420;

      if(token0 == lava_token || token1 == lava_token){
        if(token0 == lava_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
      }
      return 1;
    },

    getLAVARECLPTotalValue:async ({ commit }, obj) => {
      
      // console.log('=== into === getJGNBNBLPTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x7275278C94b5e20708380561C4Af98F38dDC6374', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      // console.log('------------1')
      // console.log('token0:',token0)

      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      // console.log('------------2')
      // console.log('token1:',token1)

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------3')
      // console.log('totalSupply:',totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0xf036C1226eafa96a2fE8933A52ac450AD171dAF4');

      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      // console.log('---------------4')
      // console.log('balance:',balance)

      let ration = balance / totalSuppy


      // console.log('-----------')

      let lava_token = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
      let lava_price = 600;

      if(token0 == lava_token || token1 == lava_token){
        if(token0 == lava_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
      }
      return 1;
    },
    
    getLAVARECLPTotalValue2:async ({ commit }, obj) => {
      
      // console.log('=== into === getJGNBNBLPTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x7275278C94b5e20708380561C4Af98F38dDC6374', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      // console.log('------------1')
      // console.log('token0:',token0)

      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      // console.log('------------2')
      // console.log('token1:',token1)

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------3')
      // console.log('totalSupply:',totalSuppy)
      let balance = await vaults_WithSigner.balanceOf('0x3311354798880eF029405c52BB275d10A69A9cde');

      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      // console.log('---------------4')
      // console.log('balance:',balance)

      let ration = balance / totalSuppy


      // console.log('-----------')

      let lava_token = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
      let lava_price = 600;

      if(token0 == lava_token || token1 == lava_token){
        if(token0 == lava_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
      }
      return 1;
    },


    getFormPrice:async ({ commit }, obj) => {
      
      console.log('=== into === getFormPrice')
      
      let token_address = '0x1b24d4179070a2a79be891d9e64649446a043309'
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
      let result = await vaults_WithSigner.getReserves();
      

      let token0Num = result[0]
      let token1Num = result[1]

      

      token0Num = formatUnits(token0Num,18)
      token0Num = parseFloat(token0Num)

      console.log(token0Num)

      token1Num = formatUnits(token1Num,18)
      token1Num = parseFloat(token1Num)

      console.log(token1Num)
      
      let price = token1Num / token0Num
      console.log('-------------------getFormPrice price')
      console.log(price)
      return price;
      
    },


    getFOMPTPTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getFOMPTPTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x27933EF78129EceE3e048055B1E0fB9d136d415E', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0xe9503aa48f3Cb0e540c64cdd00848c29A2720BE5');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let fomp_token = '0x2ac548bc73f6a3558aced24b6261fc87f1c428b7';
      let fomp_price = 40;

      if(token0 == fomp_token || token1 == fomp_token){
        if(token0 == fomp_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*fomp_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*fomp_price*2*ration;
        }
      }
      return 1;
    },


    getFOMPUSDTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getFOMPUSDTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x1b24D4179070a2a79be891d9E64649446a043309', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x9428b5ACe2B3a427Ba44A1183eCc779df6631a29');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let usdt_price = 1;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    getFOMAUSDTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getFOMAUSDTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x6A32EdCb7C4b4F531d228f408aDFA95Da5d0a2ae', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0xEe90Be0Fa394f3C18e14eD4096A3F99f3Ddac11F');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let usdt_price = 1;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },



    getFilDAUSDTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getFilDAUSDTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x961d2B834b403A097247D8E557D26A6C72B1A99C', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0xDa727832A0d9F11bC860cB7549D89c1584111567');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let usdt_price = 1;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    getFilDALAVLPTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getFilDALAVLPTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0xa45f787143Ed49EF8D71a06DB81aF114037C7f84', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      // let balance = await vaults_WithSigner.balanceOf('0xDa727832A0d9F11bC860cB7549D89c1584111567');
      // balance = formatUnits(balance,18)
      // balance = parseFloat(balance)
      let balance = 1122.559

      console.log(balance)

      let ration = balance / totalSuppy

      let lava_token = '0x56f95662e71f30b333b456439248c6de589082a4';
      let lava_price = 0.65;

      if(token0 == lava_token || token1 == lava_token){
        if(token0 == lava_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*lava_price*2*ration;
        }
      }
      return 1;
    },


    getVIBKPrice:async ({ commit }, obj) => {
      
      console.log('=== into === getVIBKPrice')
      
      let token_address = '0x666267FFfefd5452605803567B57832A65FE74bC'
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
      let result = await vaults_WithSigner.getReserves();
      
      //lava - token0
      //vibk - token1

      let token0Num = result[0]
      let token1Num = result[1]

      // console.log('**************111111111')
      // console.log(token0Num);
      // console.log(token1Num);

      token0Num = formatUnits(token0Num,18)
      token0Num = parseFloat(token0Num)

      // console.log(token0Num)

      token1Num = formatUnits(token1Num,8)
      token1Num = parseFloat(token1Num)

      // console.log(token1Num)
      let token0_price = 0.6;

      let price = token0Num * token0_price / token1Num;

      console.log('-------------------getVIBKPrice price')
      console.log(price)
      return price;
      
    },

    getVIBKLAVATotalValue:async ({ commit }, obj) => {
      
      // console.log('=== into === getVIBKLAVATotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x666267FFfefd5452605803567B57832A65FE74bC', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,8)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------')
      // console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x0004D34997Fe9ab10fD4AB889D16f87f38912330');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      // console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0x56f95662e71f30b333b456439248c6de589082a4';
      let usdt_price = 0.6;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,8)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,8)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    getVIBKNULSTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getVIBKNULSTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0xE99832350AC4d3401CD49cEEF8765D71a627288f', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,8)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------')
      // console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x263B2612D60061e7c877028f037837214CBb5fA8');
      balance = formatUnits(balance,8)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xd938e45680da19ad36646ae8d4c671b2b1270f39';
      let usdt_price = 1.44;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,8)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,8)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    getDATTNULSTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getDATTNULSTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0xf0d134aad095173eea6c48eb1dbb49c8341ab9d9', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,8)
      totalSuppy = parseFloat(totalSuppy)

      // console.log('---------------')
      // console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x3d2E199265525451C3c38546fdD436C176BfA4e7');
      balance = formatUnits(balance,8)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xd938e45680da19ad36646ae8d4c671b2b1270f39';
      let usdt_price = 1.44;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,8)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,8)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    getDATTUSDTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getDATTUSDTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0xf121c6ba2852679426e2dcf56eeb7f0a30b05a05', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x5E452d9982DFd399999b32D0356206F58C8891bc');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let usdt_price = 1;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },
    
    getDATTPrice:async ({ commit }, obj) => {
      
      console.log('=== into === getDATTPrice')
      
      let token_address = '0xf121c6ba2852679426e2dcf56eeb7f0a30b05a05'
      const signer = web3.getSigner();
      const vaults_contract = new Contract(token_address, PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      // let {token0Num, token1Num,_p} = await vaults_WithSigner.getReserves();
      let result = await vaults_WithSigner.getReserves();
      
      //datt - token0
      //usdt - token1

      let token0Num = result[0]
      let token1Num = result[1]

      console.log('**************111111111')
      console.log(token0Num);
      console.log(token1Num);

      token0Num = formatUnits(token0Num,18)
      token0Num = parseFloat(token0Num)

      console.log(token0Num)

      token1Num = formatUnits(token1Num,18)
      token1Num = parseFloat(token1Num)

      console.log(token1Num)
      let token1_price = 1;

      let price = token1Num * token1_price / token0Num;

      console.log('-------------------getDATTPrice price')
      console.log(price)
      return price;
      
    },


    getSATOUSDTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getSATOUSDTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0x1587064250B32593AC8b9190fc38792eeC9FE85d', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0xA49B09b89D12f3fDdcD79988360bbbc9b37Ee466');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let usdt_price = 1;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    getARCHUSDTTotalValue:async ({ commit }, obj) => {
      
      console.log('=== into === getARCHUSDTTotalValue',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract('0xEEc243468cc46381bb1aB38214EC7131f6121e50', PAIR_POOL_ADDRESS_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);

      
      let result = await vaults_WithSigner.getReserves();
      let token0Num = result[0]
      let token1Num = result[1]

      let token0 = await vaults_WithSigner.token0();
      token0 = token0.toLowerCase();
      
      let token1 = await vaults_WithSigner.token1();
      token1 = token1.toLowerCase()

      let totalSuppy = await vaults_WithSigner.totalSupply();
      totalSuppy = formatUnits(totalSuppy,18)
      totalSuppy = parseFloat(totalSuppy)

      console.log('---------------')
      console.log(totalSuppy)

      let balance = await vaults_WithSigner.balanceOf('0x8170E35C9676dcba9263ED612fd23871C0611f69');
      balance = formatUnits(balance,18)
      balance = parseFloat(balance)

      console.log(balance)

      let ration = balance / totalSuppy

      let usdt_token = '0xa71edc38d189767582c38a3145b5873052c3e47a';
      let usdt_price = 1;

      if(token0 == usdt_token || token1 == usdt_token){
        if(token0 == usdt_token){
          let b = formatUnits(token0Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
        else{
          let b = formatUnits(token1Num,18)
          return parseFloat(b)*usdt_price*2*ration;
        }
      }
      return 1;
    },


    // ===============================

    // iLAVAPart Functions

    // =================================
    //是否已经approve了Lava
    iLAVA_hasApproveLava: async ({ commit },obj) => {
      // console.log('=== into === iLAVA_hasApproveLava',obj);
      let {address} = obj
      const signer = web3.getSigner();
      const lp_contract = new Contract(iLAVA_LAVA_ADDRESS, LAVA_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      const b_num = await lp_WithSigner.allowance(address,iLAVA_ADDRESS);
      if(b_num > 0){
        return true;
      }
      return false;
    },
  
    //approve Lava
    iLAVA_approveLava: async (context,obj) => {
      // console.log('=== into === iLAVA_approveLava')
      
      const signer = web3.getSigner();
      const lp_contract = new Contract(iLAVA_LAVA_ADDRESS, LAVA_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);

      try{
        await lp_WithSigner.approve(iLAVA_ADDRESS,parseUnits('1',36));
        // callback
        if(obj && obj.callback){
          obj.callback()
        }
      }
      catch{
        // callbackOnErr
        if (obj && obj.callbackOnErr) {
          obj.callbackOnErr()
        }
      }
      
    },

    //得到Lava的数量
    iLAVA_getLavaBalance:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getLavaBalance',obj)
      let {address} = obj;
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_LAVA_ADDRESS, LAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.balanceOf(address);
      let b = formatUnits(b_num,18)
      return b;
    },

    //铸造
    iLAVA_mint: async (context,obj) => {
      // console.log('=== into === iLAVA_mint')
      let {lavaAmount} = obj;
      let amount = parseUnits(lavaAmount.toString(),18);
      console.log(amount);

      const signer = web3.getSigner();
      const lp_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      
      try{

        var tx = await lp_WithSigner.mint(amount,iLAVA_TEAM_ADDRESS);
        console.log(tx)
        await web3.waitForTransaction(tx.hash);
        let receipt = await web3.getTransactionReceipt(tx.hash);
        console.log(receipt);
        var transctions_hash = receipt.transactionHash
        console.log(transctions_hash);
  
        // callback
        if(obj && obj.callback){
          obj.callback()
        }
      }
      catch{
        // callbackOnErr
        if(obj && obj.callbackOnErr){
          obj.callbackOnErr()
        }
      }
    },

    //得到iLAVA的数量
    iLAVA_getiLavaBalance:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getiLavaBalance',obj)
      let {address} = obj;
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.balanceOf(address);
      let b = formatUnits(b_num,18)
      return b;
    },

    //赎回
    //isAll的参数是bool型
    iLAVA_redeem: async (context,obj) => {
      // console.log('=== into === iLAVA_redeem',obj);
      let {lavaAmount,isAll} = obj;
      let amount = parseUnits(lavaAmount.toString(),18);
      console.log(amount);
      const signer = web3.getSigner();
      const lp_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI, web3);
      const lp_WithSigner = lp_contract.connect(signer);
      
      try{
        var tx = await lp_WithSigner.redeem(amount,isAll);

        await web3.waitForTransaction(tx.hash);
        let receipt = await web3.getTransactionReceipt(tx.hash);
        console.log(receipt);
        var transctions_hash = receipt.transactionHash
        console.log(transctions_hash);
        
        // callback
        if(obj && obj.callback){
          obj.callback()
        }
      }
      catch{
        // callbackOnErr
        if(obj && obj.callbackOnErr){
          obj.callbackOnErr()
        }
      }
    },


    //得到统计部分总铸造vDODO
    iLAVA_getiLavaTotalSupply:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getiLavaTotalSupply',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.totalSupply();
      let b = formatUnits(b_num,18)
      return b;
    },

    //得到退会费收入
    iLAVA_getReemTotal:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getReemTotal',obj)
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.totalWithdrawFee();
      let b = formatUnits(b_num,18)
      return parseFloat(b) / 100;
    },

    //得到多少人成为会员
    iLAVA_getMembers:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getMembers',obj)
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.totalUsers();
      return b_num;
    },

    //得到年化率
    iLAVA_getAPY:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getAPY',obj)
      
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.totalSupply();
      let b = formatUnits(b_num,18);
      let total = parseFloat(b) * 100;

      let reward_per_block = 0.56;
      let y = reward_per_block * (3600 * 24 / 3) * 365;

      let y0 = reward_per_block * (3600 * 24 / 3);
      console.log('-----------:')
      console.log(y0/total);
      let y2 = 1 + y0 / total
      console.log(y2)
      let y1 = (1 + y0 / total) ** 365 - 1
      console.log(y1);
      return y1;
      
      // return y / total;
    },

    //得到会员奖励
    iLAVA_getILAVAReward:async ({ commit }, obj) => {
      // console.log('=== into === iLAVA_getILAVAReward',obj)
      let {address} = obj;
      const signer = web3.getSigner();
      const vaults_contract = new Contract(iLAVA_ADDRESS, iLAVA_ABI,web3);
      const vaults_WithSigner = vaults_contract.connect(signer);
      let b_num = await vaults_WithSigner.lavaBalanceOf(address);
      let b = formatUnits(b_num,18);
      let b_total = parseFloat(b) / 100;
      
      let a_num = await vaults_WithSigner.userInfo(address);
      let a = formatUnits(a_num['originAmount'],18);
      let a_total = parseFloat(a) / 100;
      return b_total - a_total;
    },


  };

export default {
  state,
  mutations,
  actions
};
